jQuery(($) => {
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Browser - Keydown Focus Class
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('body').on('keydown', function() {
    if ( !$('.keyboard-in-use')[0] ) {
      $(this).addClass('keyboard-in-use');
    }
  });

  $('body').on('mousedown', function() {
    if ( $('.keyboard-in-use')[0] ) {
      $(this).removeClass('keyboard-in-use');
    }
  });


  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Molecule: Audio Player
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  if ($(".m-audio-player")[0]) {
    Plyr.setup('.m-audio-player__audio', {
      type      : 'audio',
      loadSprite: false,
      controls  : [
        'play',
        'rewind',
        'fast-forward',
        'volume',
        'current-time',
        'duration',
        'progress',
      ]
    });
  }


  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Atom - Back to Top
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  if ( $('.a-back-to-top')[0] ) {
    $('.a-back-to-top').click(function() {
      window.scrollTo({top: 0, behavior: 'smooth'});
    });
  }


  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Atom: Toggle
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  if( $('header')[0] ){
    $('.a-toggle').click(function() {
      const page_nav = $('.o-header__nav');
      const top_nav  = $('.o-header__secondary-nav');
      const tabs     = $('.o-header__tabs');
      const main     = $('main');
      const header   = $('.o-header');

      $(this).toggleClass('a-toggle--active');
      page_nav.toggleClass('o-header__nav--open');
      main.toggleClass('nav--open');
      header.toggleClass('o-header--open');
      
      if($(window).width() <= 768){
        top_nav.toggleClass('o-header__secondary-nav--open');
        tabs.toggleClass('o-header__tabs--open');
      }else{
        return;
      }
    });
  }


  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Molecule: Post Carousel
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  if ( $('.m-post-carousel')[0] ) {
    $('.m-post-carousel__list').slick({
      speed: 400,
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 950,
          settings: {
            slidesToShow:2,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow:1,
          }
        },
      ]
    });
  }


  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Molecule: Small Post Carousel
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  if ( $('.m-small-post-carousel')[0] ) {
    $('.m-small-post-carousel__list').slick({
      speed: 400,
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite: false,
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 950,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });
  }


  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Organism - Post Filter
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  if ( $('.o-post-filter__years')[0] ) {
    setTimeout(function() {
      $('.o-post-filter .facetwp-facet-years').each(function() {
        const $active      = $(this).find('.facetwp-checkbox.checked');
        const activeOffset = $active.offset().left;
        const activeWidth  = $active.innerWidth();
  
        const $list      = $(this);
        const listScroll = $list.scrollLeft();
        const listWidth  = $list.width();
  
        $list.scrollLeft(activeOffset + activeWidth/2 + listScroll - listWidth/2);
      });
    }, 100);

    $('.o-post-filter__arrow').click(function() {
      const $filter = $(this).closest('.o-post-filter');
      const $list   = $filter.find('.facetwp-facet-years');

      const listScroll = $list.scrollLeft();
      const listWidth  = $list.width();

      $list.animate({
        scrollLeft: listScroll+(listWidth/2)
      });
    });

    $('.o-post-filter__toggle').click(function() {
      const toggleText  = $(this).attr('data-toggle');
      const currentText = $(this).text();

      $(this).text(toggleText);
      $(this).attr('data-toggle', currentText);
      $('.m-posts').toggleClass('m-posts--list');
    });
  }


  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Organism - Resource Picker
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  if ( $('.o-resource-picker')[0] ) {
    $('#resource_sortby').change(function(){
      var $type = $('#resource_type').find('option:selected'),
          $sort = $(this).find('option:selected');

      var type     = $type.data('type'),
          url      = $sort.val(),
          operator = url.indexOf('?') == -1 ? '?' : '&';

      if (type) {
          url = url + operator + '_resource_types=' + type;
      }

      window.location.href = url;
    });
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Molecule - Search
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  if( $('.m-search')[0] ){
    $('.m-search__submit').click(function(e) {
      if($(this).attr('type') === 'button'){
        e.preventDefault();
        const search_form = $('.m-search__form');
        const logo        = $('.o-header__logo');

        search_form.addClass('m-search__form--active');
        logo.addClass('o-header__logo--hide');
        $(this).attr('type', 'submit');

      }else{
        return;
      }
    });

    $(document).on('click', function (e) {
      if ($(e.target).closest(".m-search").length === 0) {
          const search_form   = $('.m-search__form');
          const search_submit = $('.m-search__submit');
          const logo          = $('.o-header__logo');

          search_submit.attr('type', 'button');
          search_form.removeClass('m-search__form--active');
          logo.removeClass('o-header__logo--hide');
      }
  });
  }

//≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
// ✅ Molecule - Upcoming Posts
//≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  if( $('.m-upcoming-posts')[0] ){

    $('button.o-featured-episode__link').click(function() {
      const upcoming_posts = $('.m-upcoming-posts');

      upcoming_posts.addClass('m-upcoming-posts--active');

    });

    $('.m-upcoming-posts__button').click(function () {
      const upcoming_posts = $('.m-upcoming-posts');

      upcoming_posts.removeClass('m-upcoming-posts--active');
    });

  }
});

